import { render, staticRenderFns } from "./InforControl.vue?vue&type=template&id=990e56ec&scoped=true"
import script from "./InforControl.vue?vue&type=script&lang=js"
export * from "./InforControl.vue?vue&type=script&lang=js"
import style0 from "./InforControl.vue?vue&type=style&index=0&id=990e56ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990e56ec",
  null
  
)

export default component.exports